import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentOrderLineItem } from "@redotech/redo-fulfillment-group-common/fulfillment-order-line-item";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

function formatCustomAttributes(item: FulfillmentOrderLineItem): string {
  return item.customAttributes
    .filter(
      ({ value }) => value !== "" && value !== null && value !== undefined,
    )
    .map(({ key, value }) => `${key}: ${value}`)
    .join(", ");
}

export const LineItemCustomAttributesCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Line item custom attributes",
    cell: (row) => {
      const strings = (row.items ?? [])
        .map(formatCustomAttributes)
        .filter((s) => s.length > 0);
      return Array.from(new Set(strings)).join(" | ");
    },
    expandedCsvCell: (row, expansionIndex) => {
      const item = getExpandedItems(row)?.[expansionIndex];
      return item ? formatCustomAttributes(item) : "";
    },
  };
